import { ref } from 'vue';

const toastInstance = ref(null);

export function useToast() {
    const show = (message, type = 'info', duration = 3000) => {
        if (toastInstance.value) {
            toastInstance.value.addToast(message, type, duration);
        }
    };

    return {
        success: (message, duration = 3000) => show(message, 'success', duration),
        error: (message, duration = 5000) => show(message, 'error', duration),
        warning: (message, duration = 4000) => show(message, 'warning', duration),
        info: (message, duration = 3000) => show(message, 'info', duration),
        setInstance: (instance) => {
            toastInstance.value = instance;
        }
    };
}
